<template>
  <div class="about-us">
    <v-card class="common-card lighten-4">
      <h4 class="shopDeeppurple--text fs-xxlarge">مشاوره تحصیلی</h4>
      <v-row class="d-flex flex-row line-response_item">
        <v-col xl="6" lg="6" md="8" sm="12" xs="12">
          <div class="mt-8 mainFont--text">
            <p>
              مشاوران ما در تلاش هستند بهترین و به روزترین اقدامات کمک آموزشی،
              تحصیلی، و راهنمایی شغلی را در اختیار شما قرار دهند. می‌توانید از
              طریق راه‌های تماس ذکر شده در بخش مربوطه و یا با پر کردن فرم مشاوره
              زیر، با ما در ارتباط باشید. توجه داشته باشید که هر چقدر اطلاعات و
              جزییات بیشتری در اختیار ما بگذارید، تیم مشاورین ما بهترین اقدامات
              را برای شما ارائه خواهند کرد.
            </p>
          </div>
        </v-col>
      </v-row>
      <form ref="form">
        <div class="line-response_item">
          <v-col xl="3" lg="3" md="4" sm="6" xs="6">
            <v-text-field
              append-icon="mdi-account"
              placeholder="نام "
              outlined
              dense
              hide-details
              v-model="name"
            ></v-text-field>
          </v-col>
          <v-col xl="3" lg="3" md="4" sm="6" xs="6">
            <v-text-field
              append-icon="mdi-account"
              placeholder="نام خانوادگی "
              outlined
              dense
              hide-details
              v-model="lastName"
            ></v-text-field>
          </v-col>
        </div>
        <div class="line-response_item">
          <v-col xl="3" lg="3" md="4" sm="6" xs="6">
            <v-text-field
              append-icon="mdi-email"
              placeholder="ایمیل"
              outlined
              dense
              hide-details
              v-model="email"
            ></v-text-field>
            <span
              class="red--text text-right"
              v-if="email != '-' && !validateEmail(email)"
              >ایمیل وارد شده صحیح نمی‌باشد.</span
            >
          </v-col>

          <v-col xl="3" lg="3" md="4" sm="6" xs="6">
            <v-text-field
              append-icon="mdi-phone"
              placeholder="شماره موبایل"
              outlined
              dense
              hide-details
              type="number"
              v-model="mobile"
            ></v-text-field>
            <span
              class="red--text text-right mb-3 pt-0 mt-0"
              v-if="mobile && !validateMobileNumber(mobile)"
              >شماره موبایل وارد شده صحیح نمی‌باشد.</span
            >
          </v-col>
        </div>
        <div class="line-response_item">
          <v-col xl="6" lg="6" md="8" sm="12" xs="12">
            <v-textarea
              outlined
              dense
              hide-details
              placeholder="توضیحات خود را وارد نمایید"
              v-model="description"
            >
            </v-textarea>
          </v-col>
        </div>
      </form>
      <div class="line-response_item">
        <v-col xl="3" lg="3" md="8" sm="12" xs="12">
          <v-btn
            :loading="busy"
            :disabled="busy || disableSend"
            height="40"
            block
            class="purple2-mainBtn"
            @click="newconsultation"
            >ارسال پیام
          </v-btn>
        </v-col>
      </div>
    </v-card>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  name: "AcademicAdvice",
  data() {
    return {
      busy: false,
      name: "",
      lastName: "",
      email: "",
      mobile: "",
      description: "",
    };
  },
  metaInfo() {
    return {
      title: `مشاوره تحصیلی| کتاب باز`, // Meta title
      meta: [
        {
          name: "description",
          content:
            "شما می‌توانید با ثبت درخواست، از مشاوره مشاورین زبده و با تجربه کتا باز بهرمند شوید.", // Meta description
        },
        {
          property: "og:title", // Open Graph meta tag
          content: "مشاوره تحصیلی",
        },
        {
          property: "og:description",
          content:
            "شما می‌توانید با ثبت درخواست، از مشاوره مشاورین زبده و با تجربه کتا باز بهرمند شوید.",
        },
      ],
    };
  },
  beforeDestroy() {
    // Reset the meta title when leaving the page
    document.title = "کتاب باز"; // Replace with your default title
    // Optionally, remove any other meta tags
    const metaTags = document.querySelectorAll(
      "meta[data-vue-router-controlled]"
    );
    metaTags.forEach((tag) => tag.parentNode.removeChild(tag));
  },
  methods: {
    validateMobileNumber(mobile) {
      const pattern = /^(?:\+98|0)?9\d{9}$/; // Regex pattern for Iranian mobile mobile
      return pattern.test(mobile);
    },
    newconsultation() {
      this.busy = true;
      Axios.post(
        this.baseUrl + "/onlineShop/consultation/new",
        {
          name: this.name,
          lastName: this.lastName,
          mobile: this.mobile,
          email: this.email,
          description: this.description,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.busy = false;
            this.name = "";
            this.lastName = "";
            this.mobile = "";
            this.email = "";
            this.description = "";
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.busy = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },
  },
  computed: {
    disableSend() {
      if (this.name && this.lastName && this.mobile && this.email) {
        if (
          this.name.length >= 3 &&
          this.lastName.length >= 3 &&
          this.validateMobileNumber(this.mobile) &&
          this.validateEmail(this.email)
        ) {
          return false;
        } else return true;
      } else return true;
    },
  },
};
</script>

<style lang="scss">
.line-response_item {
  display: flex;
  flex-wrap: wrap;
  @media only screen and (max-width: 375px) {
    flex-direction: column;
  }
}
.about-us {
  overflow: hidden;
  .common-card {
    position: relative;
    min-height: 300px;
    @media only screen and (max-width: 600px) {
      padding-bottom: 250px !important;
    }
    .image-box {
      position: absolute;
      left: 30px;
      width: 200px;
      height: 200px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      @media only screen and (max-width: 600px) {
        left: 10px;
      }
    }
  }
}
</style>
